module.exports = __webpack_public_path__ + "static/media/watermark-the-agent.273fa0bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/WatermarkOverlay/watermark-the-agent.png
// module id = 921
// module chunks = 0